import React from 'react'
import { Table, TableBody, TableHead, Box } from '@mui/material'
import { TableBodyRow, TableHeaderRow } from '../../../../../components/customTable/tableRow'

import CampaignMagnetScore from './campaignMagnetScore'
import LegendRow from './legendRow'
import SearchReportButton from './searchReportButton'
import InteractionBar from './interactionBar'
import { IconReportSearch } from '../../../../../assets/images/icons'
import { InteractionWrap, TableWrap, SmallGraphWrapper } from './style'
import AdaptiveGauge from '../guardChart'

const columnSx = {
  fontWeight: '600 !important',
}

const headerMeta = [
  {
    id: 'TriggerName',
    label: 'Campaign',
    minWidth: '18%',
    align: 'right',
  },
  {
    id: 'SentimentEngagement',
    label: 'Sentiment',
    minWidth: '16%',
    sx: columnSx,
  },
  {
    id: 'Engagement',
    label: 'Engagement',
    // minWidth: '12%',
    sx: columnSx,
  },
  {
    id: 'InteractionsPaidInteractions',
    label: 'Interactions',
    // minWidth: '18%',
    sx: columnSx,
  },
  {
    id: 'BrandAssociation',
    label: 'Brand Association',
    // minWidth: '15%',
    sx: columnSx,
  },
  {
    id: 'CampaignMagnetScore',
    label: 'Magnet Score',
    minWidth: '6%',
    sx: columnSx,
  },
  { id: 'Action', label: '', align: 'left', minWidth: '2%' },
]

const SandBoxDataTable = ({ data }) => {
  return (
    <TableWrap className='campaignTriggersRow tableWrap pptSectionWrap'>
      <Table stickyHeader aria-label='sticky table'>
        <TableHead>
          <TableHeaderRow headerMeta={headerMeta} />
        </TableHead>
        <TableBody>
          {data?.map((modul, index) => {
            const valAtRight1 = modul.barData['SentimentEngagement'].bar[0].Positive - modul.barData['SentimentEngagement'].bar[0].Negative
            const valAtRight2 = ( valAtRight1 > 0 ) ? '+'+valAtRight1 : ''+valAtRight1

            // if(index === 0) return null
            const updatedModul = {
              ...modul,
              TriggerName: <Box className='triggerName'>{modul.TriggerName}</Box>,
              SentimentEngagement: (
                <CampaignMagnetScore
                  rowData={modul}
                  barData={modul.barData['SentimentEngagement'].bar}
                  maxPercentRatio={modul.barData['SentimentEngagement'].maxPercentRatio}
                  valueInPercent={true}
                  showToolTip={true}
                  valueAtRight={valAtRight2}
                />
              ),
              Engagement: (
                <Box className='engagementValue'>
                  <InteractionBar engagement={modul.Engagement} />
                </Box>
              ),
              InteractionsPaidInteractions: (
                <InteractionWrap>
                  <InteractionBar organic={modul.EarnedOrganicReach} paid={modul.PaidReach} />
                </InteractionWrap>
              ),
              BrandAssociation: (
                <CampaignMagnetScore
                  rowData={modul}
                  background={modul.barData['BrandAssociation'].background}
                  barData={modul.barData['BrandAssociation'].bar}
                  valueInPercent={true}
                  maxPercentRatio={100}
                />
              ),
              CampaignMagnetScore__: (
                <CampaignMagnetScore
                  barData={modul.barData['CampaignMagnetScore'].bar}
                  rowData={modul}
                  maxPercentRatio={modul.barData['CampaignMagnetScore'].maxPercentRatio}
                  endIcon={modul.barData['CampaignMagnetScore'].icon}
                />
              ),
              CampaignMagnetScore: (
                <>
                  <SmallGraphWrapper><AdaptiveGauge size="small" value={modul.CampaignMagnetScore} /></SmallGraphWrapper>
                </>
              ),
              Action: <SearchReportButton id={modul.TriggerId} />,
              sx: {
                paddingRight: '5px',
                paddingLeft: '5px',
              },
            }
            return (
              <TableBodyRow
                key={index + modul.TriggerName}
                rowData={updatedModul}
                headerMeta={headerMeta}
              />
            )
          })}
        </TableBody>
      </Table>
      <LegendRow />
    </TableWrap>
  )
}

export default SandBoxDataTable
